import {formatNumber} from "../../../../components/FormatNumber";
import {Type} from "../../helper";
import {Big} from "../../calculation/helper";
// import { DepositItemHelper } from "../../../../components/Editable/PaymentDepositItem/helper";
// import { select } from 'bukku/shared/SagaService';

function sortLinkItems(linkItems) {
    const paidLinkItems = linkItems.filter(linkItem => linkItem.apply_amount);
    const unpaidLinkItems = linkItems.filter(linkItem => !linkItem.apply_amount);

    return [...paidLinkItems, ...unpaidLinkItems];
}

export function parseTransaction(transaction) {
    const txn = {...transaction};

    // when restoring autosave transactions, don't let Tags show an empty Tag if no tags
    if (!txn.tag_ids || txn.tag_ids?.length === 0)
        txn.tag_ids = [];

    // format amount with 2 dps (12 -> '12.00')
    if (txn.amount)
        txn.amount = formatNumber(txn.amount, 2, undefined, false);

    if (txn.form_items) {
        txn.form_items = txn.form_items.map(formItem => {
            const { key, balance_quantity, quantity } = formItem;

            return {
                ...formItem,
                line: key,
                transferred_to_quantity: (
                    (balance_quantity || balance_quantity === 0) ?
                        Math.max(((quantity || 0) - (balance_quantity || 0)), 0) :
                        undefined
                ),
            };
        });
    }

    if (txn.deposit_items) {
        // const defaultFeeAccount = yield select(
        //     state => state.List.settings?.default_transaction_fee_account_id,
        // );

        txn.deposit_items = txn.deposit_items.map(depositItem => {
            const { fee_account_id } = depositItem;

            // deal with null fee account -> set to default
            return {
                ...depositItem,
                // fee_text: showFee ? fee_text : null,
                // fee_amount: showFee ? feeAmount : null,
                fee_account_id,
                // fee_account_id: fee_account_id || defaultFeeAccount,
            };
        });
    }

    if (txn.link_items) {
        txn.link_items = txn.link_items.map(linkItem => {
            const { balance, apply_amount } = linkItem;

            return {
                ...linkItem,
                apply_amount: formatNumber(apply_amount, 2, undefined, false) || undefined,
                balance_after_apply: Big(balance).minus(Big(apply_amount)).toNumber(),
            };
        });

        txn.link_items = sortLinkItems(txn.link_items);
    }
    // Invoice only
    else if (txn.linked_items) {
        // eslint-disable-next-line no-param-reassign
        txn.link_items = txn.linked_items.map(linkItem => {
            const balanceBig = new Big(linkItem.balance || 0);
            const applyBig = new Big(linkItem.apply_amount || 0);
            const balanceAfterApplyBig = balanceBig.minus(applyBig);

            return {
                ...linkItem,
                target_transaction_id: linkItem.origin_transaction_id,
                origin_transaction_id: undefined,
                apply_amount: formatNumber(linkItem.apply_amount, 2, undefined, false),
                balance_after_apply: balanceAfterApplyBig.toNumber(),
            };
        });

        txn.link_items = sortLinkItems(txn.link_items);
    }

    if (txn.sales_link_items) {
        txn.sales_link_items = txn.sales_link_items.map(linkItem => ({
            ...linkItem,
            apply_amount: formatNumber(linkItem.apply_amount, 2, undefined, false),
        }));

        txn.sales_link_items = sortLinkItems(txn.sales_link_items);
    }

    if (txn.purchase_link_items) {
        txn.purchase_link_items = txn.purchase_link_items.map(linkItem => ({
            ...linkItem,
            apply_amount: formatNumber(linkItem.apply_amount, 2, undefined, false),
        }));

        txn.purchase_link_items = sortLinkItems(txn.purchase_link_items);
    }

    if (txn.term_items) {
        txn.term_items = txn.term_items.map(item => ({
            ...item,
            date: item.term_id ? undefined : item.date,
        }));
    }

    // For Stock Adjustment only
    if (txn.type === Type.stock_adjustment && txn.items) {
        txn.items = txn.items.map(item => ({
            ...item,
            originalQuantity: item.quantity,
        }));
    }

    return txn;
}
